import { get } from 'lodash';

import {
    EMPLOYER_ROLE,
    TALENT_EXPERT_ROLE,
    TALENYA_ROLE,
    EMPLOYER_RER_ADMIN_ROLE,
} from '../constants/UserRole';

export default class PermissionService {
    static getPermissions(user, hasEmployerRepAdminRole) {
        const isTalenyaUser = PermissionService.isTalenyaUser(user);
        const isTalentExpertUser = PermissionService.isTalentExpertUser(user);
        const isEmployerUser = PermissionService.isEmployerUser(user);
        const isEmployerRepAdmin = PermissionService.isEmployerRepAdmin(user);

        return {
            isTalenyaUser,
            isTalentExpertUser,
            isEmployerUser,
            isEmployerRepAdmin: hasEmployerRepAdminRole || isEmployerRepAdmin,
        };
    }

    static isRoleExist(user, role) {
        const roles = get(user, 'roles');

        if (!roles || roles.length === 0) {
            return false;
        }

        return roles.indexOf(role) >= 0;
    }

    static isTalenyaUser(user) {
        return this.isRoleExist(user, TALENYA_ROLE);
    }

    static isTalentExpertUser(user) {
        return this.isRoleExist(user, TALENT_EXPERT_ROLE);
    }

    static isEmployerUser(user) {
        return this.isRoleExist(user, EMPLOYER_ROLE);
    }

    static isEmployerRepAdmin(user) {
        return this.isEmployerUser(user) && this.isRoleExist(user, EMPLOYER_RER_ADMIN_ROLE);
    }
}
